import { create } from "zustand";
import { StateStorage } from "zustand/middleware";
import SecureStorage from "react-secure-storage";

// Custom storage object
const storage: StateStorage = {
  getItem: async (name: string): Promise<string | null> => {
    let data = (await SecureStorage.getItem(name)) || null;

    switch (typeof data) {
      case "string":
        return data;
      case "number":
      case "boolean":
        return data.toString();
      case "object":
        return JSON.stringify(data);
      default:
        return null;
    }
  },
  setItem: async (name: string, value: string): Promise<void> => {
    await SecureStorage.setItem(name, value);
  },
  removeItem: async (name: string): Promise<void> => {
    await SecureStorage.removeItem(name);
  },
};

export { storage };
